import React from 'react';
import Carousel from '@comp/Carousel/Carousel';
import styled from '@emotion/styled';
import useWindowSize from '@hooks/useWindowSize';
import { mediaQuery, Spacings } from '@styles/index';
import ContinueWatchingCard from './ContinueWatchingCard';

type ContinueCardType = {
  uuid: string;
  slug: string;
  title: string;
  cover: string;
  order: number;
  watchedDuration: number | null;
  duration: number;
  course: any;
};

interface ContinueWatchingProps {
  continueItems: ContinueCardType[];
}

const CarouselComp = Carousel as any;

const Wrapper = styled.div`
  ${mediaQuery.uptoTablet} {
    overflow: hidden;
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const ContinueWatching: React.FC<ContinueWatchingProps> = ({
  continueItems
}) => {
  const { isMobile } = useWindowSize();

  const gridTemplateColumns = (continueItems.length || 1) * 7;

  return (
    <Wrapper>
      <CarouselComp
        numberOfItems={4}
        minItems={1}
        showControls
        gridTemplateColumns={gridTemplateColumns}
        showInfo={false}
        gridColumnGap={isMobile ? Spacings.SPACING_22 : Spacings.SPACING_6B}
        gridColumn="span 6"
        itemGridColumn="span 6"
        isUnIconArrow
        showBottomGap={false}
        paddingBottom="0"
        key="continue-watching"
      >
        {continueItems.map((card) => (
          <React.Fragment key={card.uuid}>
            <ContinueWatchingCard
              slug={card.slug}
              duration={card.duration}
              title={card.title}
              cover={card.cover}
              watchedDuration={card.watchedDuration}
              order={card.order}
              course={card.course}
            />
          </React.Fragment>
        ))}
      </CarouselComp>
    </Wrapper>
  );
};

ContinueWatching.displayName = 'ContinueWatching';

export default ContinueWatching;
